__webpack_require__.p = "https://assets.socrative.com/5.6.2/js/";